import { gql } from '@apollo/client';
import { SPOT_ALERT_INFO, USER_LOCATION_INFO, USER_LONG_INFO } from './user-fragments';

export const SET_LOCATION_MUTATION = gql`
    mutation updateUser($id: ID!, $latitude: Float, $longitude: Float, $state: String, $city: String) {
        updateUser(id: $id, latitude: $latitude, longitude: $longitude, state: $state, city: $city) {
            id
            ...UserLocationInfo
        }
    }
    ${USER_LOCATION_INFO}
`;

export const GET_INVITE_URL = gql`
    mutation getInviteUrl($inviteType: InvitedAs) {
        getInviteUrl(inviteType: $inviteType)
    }
`;

export const USER_INVITE_DATE_MUTATION = gql`
    mutation updateUser($id: ID!, $showInviteAt: ISO8601DateTime) {
        updateUser(id: $id, showInviteAt: $showInviteAt) {
            showInviteAt
        }
    }
`;

export const UPDATE_SPOT_ALERT_MUTATION = gql`
    mutation updateSpotAlert(
        $radius: Int
        $enclosureType: AlertEnclosure
        $minimumSize: Float
        $dogsAllowed: Boolean
        $active: Boolean
        $latitude: Float
        $longitude: Float
    ) {
        updateSpotAlert(
            latitude: $latitude
            longitude: $longitude
            radius: $radius
            enclosureType: $enclosureType
            minimumSize: $minimumSize
            dogsAllowed: $dogsAllowed
            active: $active
        ) {
            ...SpotAlertInfo
        }
    }
    ${SPOT_ALERT_INFO}
`;

export const UPDATE_USER_MUTATION = gql`
    mutation updateUser(
        $id: ID!
        $bookingReminders: Boolean
        $firstname: String
        $lastname: String
        $phoneNumber: String
        $about: String
        $aboutHost: String
        $aboutHostMore: String
        $email: String
        $firstHear: String
        $firstHearSocialMedia: String
        $referralCode: String
        $tosAgree: Boolean
        $vaccinated: Boolean
        $hostWelcomeMessageBanner: Boolean
        $hostWelcomeMessageText: String
        $hostWelcomeMessagesOn: Boolean
        $hostThankYouMessageText: String
        $hostThankYouMessagesOn: Boolean
        $hostMode: Boolean
        $avatarAws: Upload
        $gender: String
        $birthAt: ISO8601Date
        $race: String
        $instagramUsername: String
        $payoutAccountId: String
        $hostRulesAccepted: Boolean
        $rulesAccepted: Boolean
        $showGuestBannerApp: Boolean
        $showGuestBannerFacebook: Boolean
        $showGuestBannerPhoneNumber: Boolean
        $showHostBannerBookingsAutoConfirmed: Boolean
        $showHostBannerDownloadApp: Boolean
        $showHostBannerFacebook: Boolean
        $showHostBannerMembership: Boolean
        $showHostBannerOptimizeSpotSettings: Boolean
        $showHostBannerRisingSpot: Boolean
        $showHostBannerSetupCalendar: Boolean
        $showHostBannerTopSpot: Boolean
        $showHostBannerWelcomeMessage: Boolean
        $showHostBannerMarketing: Boolean
        $testGroups: [String!]
    ) {
        updateUser(
            id: $id
            bookingReminders: $bookingReminders
            firstname: $firstname
            lastname: $lastname
            email: $email
            phoneNumber: $phoneNumber
            about: $about
            aboutHost: $aboutHost
            aboutHostMore: $aboutHostMore
            firstHear: $firstHear
            firstHearSocialMedia: $firstHearSocialMedia
            avatarAws: $avatarAws
            tosAgree: $tosAgree
            vaccinated: $vaccinated
            hostWelcomeMessageBanner: $hostWelcomeMessageBanner
            hostWelcomeMessageText: $hostWelcomeMessageText
            hostWelcomeMessagesOn: $hostWelcomeMessagesOn
            hostThankYouMessageText: $hostThankYouMessageText
            hostThankYouMessagesOn: $hostThankYouMessagesOn
            referralCode: $referralCode
            hostMode: $hostMode
            gender: $gender
            birthAt: $birthAt
            race: $race
            instagramUsername: $instagramUsername
            payoutAccountId: $payoutAccountId
            hostRulesAccepted: $hostRulesAccepted
            rulesAccepted: $rulesAccepted
            showGuestBannerApp: $showGuestBannerApp
            showGuestBannerFacebook: $showGuestBannerFacebook
            showGuestBannerPhoneNumber: $showGuestBannerPhoneNumber
            showHostBannerBookingsAutoConfirmed: $showHostBannerBookingsAutoConfirmed
            showHostBannerDownloadApp: $showHostBannerDownloadApp
            showHostBannerFacebook: $showHostBannerFacebook
            showHostBannerMembership: $showHostBannerMembership
            showHostBannerOptimizeSpotSettings: $showHostBannerOptimizeSpotSettings
            showHostBannerRisingSpot: $showHostBannerRisingSpot
            showHostBannerSetupCalendar: $showHostBannerSetupCalendar
            showHostBannerTopSpot: $showHostBannerTopSpot
            showHostBannerWelcomeMessage: $showHostBannerWelcomeMessage
            showHostBannerMarketing: $showHostBannerMarketing
            testGroups: $testGroups
        ) {
            ...UserLongInfo
        }
    }
    ${USER_LONG_INFO}
`;

export const UPDATE_USER_SIMPLE_MUTATION = gql`
    mutation updateUser(
        $id: ID!
        $bookingReminders: Boolean
        $firstname: String
        $lastname: String
        $phoneNumber: String
        $about: String
        $aboutHost: String
        $aboutHostMore: String
        $email: String
        $firstHear: String
        $firstHearSocialMedia: String
        $referralCode: String
        $tosAgree: Boolean
        $vaccinated: Boolean
        $hostWelcomeMessageBanner: Boolean
        $hostWelcomeMessageText: String
        $hostWelcomeMessagesOn: Boolean
        $hostThankYouMessageText: String
        $hostThankYouMessagesOn: Boolean
        $hostMode: Boolean
        $avatarAws: Upload
        $gender: String
        $birthAt: ISO8601Date
        $race: String
        $instagramUsername: String
        $payoutAccountId: String
        $hostRulesAccepted: Boolean
        $rulesAccepted: Boolean
        $showGuestBannerApp: Boolean
        $showGuestBannerFacebook: Boolean
        $showGuestBannerPhoneNumber: Boolean
        $showHostBannerBookingsAutoConfirmed: Boolean
        $showHostBannerDownloadApp: Boolean
        $showHostBannerFacebook: Boolean
        $showHostBannerMembership: Boolean
        $showHostBannerOptimizeSpotSettings: Boolean
        $showHostBannerRisingSpot: Boolean
        $showHostBannerSetupCalendar: Boolean
        $showHostBannerTopSpot: Boolean
        $showHostBannerWelcomeMessage: Boolean
        $showHostBannerMarketing: Boolean
        $testGroups: [String!]
    ) {
        updateUser(
            id: $id
            bookingReminders: $bookingReminders
            firstname: $firstname
            lastname: $lastname
            email: $email
            phoneNumber: $phoneNumber
            about: $about
            aboutHost: $aboutHost
            aboutHostMore: $aboutHostMore
            firstHear: $firstHear
            firstHearSocialMedia: $firstHearSocialMedia
            avatarAws: $avatarAws
            tosAgree: $tosAgree
            vaccinated: $vaccinated
            hostWelcomeMessageBanner: $hostWelcomeMessageBanner
            hostWelcomeMessageText: $hostWelcomeMessageText
            hostWelcomeMessagesOn: $hostWelcomeMessagesOn
            hostThankYouMessageText: $hostThankYouMessageText
            hostThankYouMessagesOn: $hostThankYouMessagesOn
            referralCode: $referralCode
            hostMode: $hostMode
            gender: $gender
            birthAt: $birthAt
            race: $race
            instagramUsername: $instagramUsername
            payoutAccountId: $payoutAccountId
            hostRulesAccepted: $hostRulesAccepted
            rulesAccepted: $rulesAccepted
            showGuestBannerApp: $showGuestBannerApp
            showGuestBannerFacebook: $showGuestBannerFacebook
            showGuestBannerPhoneNumber: $showGuestBannerPhoneNumber
            showHostBannerBookingsAutoConfirmed: $showHostBannerBookingsAutoConfirmed
            showHostBannerDownloadApp: $showHostBannerDownloadApp
            showHostBannerFacebook: $showHostBannerFacebook
            showHostBannerMembership: $showHostBannerMembership
            showHostBannerOptimizeSpotSettings: $showHostBannerOptimizeSpotSettings
            showHostBannerRisingSpot: $showHostBannerRisingSpot
            showHostBannerSetupCalendar: $showHostBannerSetupCalendar
            showHostBannerTopSpot: $showHostBannerTopSpot
            showHostBannerWelcomeMessage: $showHostBannerWelcomeMessage
            showHostBannerMarketing: $showHostBannerMarketing
            testGroups: $testGroups
        ) {
            id
        }
    }
`;

export const DELETE_USER_MUTATION = gql`
    mutation deleteUser {
        deleteUser {
            id
        }
    }
`;

export const REQ_MEMBERSHIP_MUTATION = gql`
    mutation requestMembership($spotId: ID!) {
        requestMembership(spotId: $spotId)
    }
`;

export const VIEW_SEARCHPAGE_FILTERS_MUTATION = gql`
    mutation viewSearchPageFilters($testGroup: Boolean!) {
        viewSearchPageFilters(testGroup: $testGroup)
    }
`;

export const VIEW_SEO_FRIENDLY_SIGNUP_MUTATION = gql`
    mutation viewSeoFriendlySignUp($testGroup: Boolean!) {
        viewSeoFriendlySignUp(testGroup: $testGroup)
    }
`;

export const VIEW_NON_AUTH_REVIEW_V2 = gql`
    mutation viewNonAuthReviewV2($testGroup: Boolean!, $sessionUuid: String, $guestSecret: String) {
        viewNonAuthReviewV2(testGroup: $testGroup, sessionUuid: $sessionUuid, guestSecret: $guestSecret)
    }
`;

export const VIEW_SNIFFPASS_HOMEPAGE_MUTATION = gql`
    mutation viewFrontSniffpassHomepage($testGroup: Boolean!, $sessionUuid: String) {
        viewFrontSniffpassHomepage(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_HAPPY_DOG_MUTATION = gql`
    mutation viewHappyDogTest($testGroup: Boolean!, $sessionUuid: String) {
        viewHappyDogTest(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_ONE_PAGE_BOOKING = gql`
    mutation viewFrontOnePageBooking($testGroup: Boolean!, $sessionUuid: String) {
        viewFrontOnePageBooking(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_OPTIONAL_SNIFFPASS_MUTATION = gql`
    mutation viewFrontOptionalInterSniffpassV2($testGroup: Boolean!, $sessionUuid: String) {
        viewFrontOptionalInterSniffpassV2(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_SPECIFIC_TIME_FILTER = gql`
    mutation viewFrontSpecificTimeFilterV6($testGroup: Boolean!, $sessionUuid: String) {
        viewSpecificTimeFilterV6(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_ENHANCED_REVIEW = gql`
    mutation viewFrontEnhancedReview($testGroup: Boolean!, $sessionUuid: String) {
        viewEnhancedReview(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_TWO_HOURS_WARN = gql`
    mutation viewFrontTwoHoursWarn($testGroup: Boolean!) {
        viewFrontTwoHoursWarn(testGroup: $testGroup)
    }
`;

export const VIEW_SPOT_LAST_ACTIVE = gql`
    mutation viewSpotLastActive($testGroup: Boolean!, $sessionUuid: String) {
        viewSpotLastActive(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_SPOT_DETAIL_FAQS = gql`
    mutation viewFrontSpotDetailFaqs($testGroup: Boolean!, $sessionUuid: String) {
        viewFrontSpotDetailFaqs(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_SMALL_DOG_FENCING = gql`
    mutation viewFrontSmallDogFencing($testGroup: Boolean!, $sessionUuid: String) {
        viewFrontSmallDogFencing(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_RECENT_REVIEWS = gql`
    mutation viewFrontRecentReviews($testGroup: Boolean!, $sessionUuid: String) {
        viewRecentReviews(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_SEARCH_60_MI = gql`
    mutation viewFrontSearch60Mi($testGroup: Boolean!, $sessionUuid: String) {
        viewSearchSixtyMilesV3(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_BACK_SEARCH_LOC_DISTANCE = gql`
    mutation viewBackSearchLocDistance($testGroup: Boolean!, $sessionUuid: String) {
        viewSearchLocDistance(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_AVAILABILITY_QUICK_FILTER = gql`
    mutation viewFrontAvailabilityQuickFilter($testGroup: Boolean!, $sessionUuid: String) {
        viewAvailabilityQuickFilterV2(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_BRONZE_NO_DISC = gql`
    mutation viewFrontBronzeNoDisc($testGroup: Boolean!, $sessionUuid: String) {
        viewBronzeNoDisc(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_LOCATION_REQUEST = gql`
    mutation viewLocationRequest($testGroup: Boolean!, $sessionUuid: String) {
        viewLocationRequest(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_LOCATION_REQUEST = gql`
    mutation viewFrontLocationRequest($testGroup: Boolean!, $sessionUuid: String) {
        viewLocationRequest(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const SIGNUP_HOST = gql`
    mutation signUp(
        $email: String!
        $firstname: String!
        $lastname: String!
        $password: String!
        $phoneNumber: String
        $uuid: String
        $invitedAs: InvitedAs
        $invitedByUuid: String
        $utmSource: String
        $utmMedium: String
        $utmCampaign: String
        $createdFrom: CreatedFrom
        $createdPlatform: CreatedPlatform
    ) {
        signUp(
            email: $email
            firstname: $firstname
            lastname: $lastname
            password: $password
            phoneNumber: $phoneNumber
            uuid: $uuid
            invitedAs: $invitedAs
            invitedByUuid: $invitedByUuid
            utmSource: $utmSource
            utmMedium: $utmMedium
            utmCampaign: $utmCampaign
            createdFrom: $createdFrom
            createdPlatform: $createdPlatform
        ) {
            id
            email
            phoneNumber
            testGroups
        }
    }
`;

export const SIGNUP_V2 = gql`
    mutation signUpV2(
        $email: String!
        $firstname: String
        $lastname: String
        $password: String
        $phoneNumber: String
        $uuid: String
        $invitedAs: InvitedAs
        $invitedByUuid: String
        $utmSource: String
        $utmMedium: String
        $utmCampaign: String
        $createdFrom: CreatedFrom
        $createdPlatform: CreatedPlatform
    ) {
        signUpV2(
            email: $email
            firstname: $firstname
            lastname: $lastname
            password: $password
            phoneNumber: $phoneNumber
            uuid: $uuid
            invitedAs: $invitedAs
            invitedByUuid: $invitedByUuid
            utmSource: $utmSource
            utmMedium: $utmMedium
            utmCampaign: $utmCampaign
            createdFrom: $createdFrom
            createdPlatform: $createdPlatform
        ) {
            id
            email
            phoneNumber
            testGroups
        }
    }
`;

export const USER_ONBOARD = gql`
    mutation onboard($firstname: String!, $lastname: String!, $password: String) {
        onboard(firstname: $firstname, lastname: $lastname, password: $password) {
            id
            status
        }
    }
`;

export const REMOVE_GOOGLE_CALENDAR = gql`
    mutation removeGoogleCalendar {
        removeGoogleCalendar
    }
`;
